import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { signIn } from '../actions/auth';
import Validator from './common/forms/Validator';
import ErrorMessage from './common/forms/ErrorMessage';
import Loader from './common/ui/Loader';
import VersionComponent from "./VersionComponent";

class SignIn extends Validator {
  static propTypes = {
    signIn: PropTypes.func.isRequired
  };

  validationRules = {
    email: { email: true },
    password: { required: true }
  };

  state = {
    email: '',
    password: '',
    isLoading: false
  };

  handleChange = event => this.setState({
    [event.target.id]: event.target.value
  });

  handleSubmit = event => {
    event.preventDefault();

    if (this.validate(this.validationRules)) {
      const { email, password } = this.state;
      const { signIn } = this.props;
      this.setState({ isLoading: true });
      signIn(email, password).then(() => {
        this.setState({ isLoading: false });
      });
    }
  };

  render () {
    if (this.state.isLoading) {
      return <div className='loader-wrapper mt-4'><Loader /></div>;
    }
    return (
      <form className='mt-4' onSubmit={this.handleSubmit}>
        <div className='form-group'>
          <label htmlFor='email'>Email</label>
          <input
            className='input'
            value={this.state.email}
            onChange={this.handleChange} type='email' id='email' />
          <ErrorMessage errorText={this.validationErrors.email} />
        </div>
        <div className='form-group'>
          <label htmlFor='password'>Password</label>
          <input
            className='input'
            value={this.state.password}
            onChange={this.handleChange} type='password' id='password' />
          <ErrorMessage errorText={this.validationErrors.password} />
        </div>
        <div className='form-group'>
          <Link to={`/reset-password`}>Forgot password?</Link>
        </div>
        <button type='submit' className='button button-primary w-100'>Log in</button>
        <div className='pt-xl-7 text-center'>
          <VersionComponent/>
        </div>
      </form>
    );
  }
}

export default connect(null, { signIn })(SignIn);



// WEBPACK FOOTER //
// ./src/components/SignIn.js